import { memo } from "react";

import { Column, Row, TagText, Text, Image } from "@bridgesplit/ui";
import { formatMultiplier } from "@bridgesplit/utils";
import { FarmingInfoExpanded, getFirstPointsIntegration } from "@bridgesplit/abf-react";

export interface RewardsProtocolPointsProps {
    farmingInfo: FarmingInfoExpanded | undefined;
    displayType?: "tag" | "badge";
}

export const RewardsProtocolPoints = memo(function RewardsProtocolPoints({
    farmingInfo,
    displayType = "tag"
}: RewardsProtocolPointsProps) {
    if (!farmingInfo) return null;
    const partnerPoints = getFirstPointsIntegration(farmingInfo);

    const logoUrl = partnerPoints?.partner?.partner.logoUrl ?? "";
    const rewardName = partnerPoints?.partner?.partner.rewardName ?? "";
    const integrationMultiplier = partnerPoints?.integrationMultiplier ?? 0;

    if (displayType === "badge") {
        // Minimalistic badge, just logo
        return (
            <Row spacing={0.5}>
                <Image src={logoUrl} size="16px" variant="circle" />
            </Row>
        );
    }

    // Default to "tag": full partner display with logo, multiplier (if any), and name
    return (
        <Column spacing={1} sx={{ width: "100%" }}>
            <Row spaceBetween>
                <Row spacing={1}>
                    <Image src={logoUrl} size="16px" variant="circle" />
                    <Text variant="body2" color="caption">
                        Points
                    </Text>
                    <TagText color="disabled">{`${rewardName} Points`}</TagText>
                </Row>
                {!!integrationMultiplier && (
                    <Text variant="body2">{formatMultiplier(integrationMultiplier, { showNa: true })}</Text>
                )}
            </Row>
        </Column>
    );
});
